module.exports = "https://la-static.vkplay.ru/promo/3/img/promo-bg.e2ed88cd.jpg";